import { SiteTheme } from 'Shared/frontend/siteTheme';
import {createContext,JSX,useContext} from 'solid-js';

const ThemeContext = createContext();

export function SettingsProvider(P:{siteTheme:SiteTheme,settingsPageName:(() => string)} & {children:JSX.Element})
{
	return (
		<ThemeContext.Provider value={P}>
			{P.children}
		</ThemeContext.Provider>
	);
}

export function useSettingsPageName()
{
	const context = useContext(ThemeContext);
	return context?.settingsPageName;
}


/* The backend renders frontend components that read this - a menu preview, a staff resource - but it
   has no site theme of its own outside them, so anything shared between the two has to ask. */
export function settingsExists():boolean
{
	return useContext(ThemeContext)?.siteTheme != undefined && useContext(ThemeContext)?.settingsPageName != undefined;
}

export function siteTheme():SiteTheme
{
	return useContext(ThemeContext).siteTheme;
}

export function palette()
{
	return siteTheme().palette;
}

export function text()
{
	return siteTheme().text;
}

export function bodyFont()
{
	return siteTheme().bodyFont;
}
